/** Convierte cruces de API a grilla editable (slot A/B por partido). */
export const crucesToSlotGrid = (cruces) => (cruces || []).map((c) => ({
  a: c.inscripcion_a_id
    ? {
      inscripcion_id: c.inscripcion_a_id,
      etiqueta: c.etiqueta_a,
      clasificacion: c.clasificacion_a,
    }
    : null,
  b: c.inscripcion_b_id
    ? {
      inscripcion_id: c.inscripcion_b_id,
      etiqueta: c.etiqueta_b,
      clasificacion: c.clasificacion_b,
    }
    : null,
}));

/** Convierte grilla editable a cruces para API. */
export const slotGridToCruces = (grid) => grid.map((m) => {
  const tieneA = Boolean(m.a?.inscripcion_id);
  const tieneB = Boolean(m.b?.inscripcion_id);
  const esBye = (tieneA && !tieneB) || (!tieneA && tieneB);

  return {
    inscripcion_a_id: m.a?.inscripcion_id ?? null,
    inscripcion_b_id: m.b?.inscripcion_id ?? null,
    etiqueta_a: m.a?.etiqueta ?? null,
    etiqueta_b: m.b?.etiqueta ?? (esBye ? 'Bye' : null),
    clasificacion_a: m.a?.clasificacion ?? null,
    clasificacion_b: m.b?.clasificacion ?? null,
    es_bye: esBye,
  };
});

export const intercambiarSlots = (grid, origen, destino) => {
  const next = grid.map((m) => ({
    a: m.a ? { ...m.a } : null,
    b: m.b ? { ...m.b } : null,
  }));
  const srcEntry = next[origen.matchIndex][origen.slot];
  const dstEntry = next[destino.matchIndex][destino.slot];
  next[origen.matchIndex][origen.slot] = dstEntry;
  next[destino.matchIndex][destino.slot] = srcEntry;
  return next;
};
